import http from "../../utils/http"
/**
 * 獲取會員基礎信息
 */
export function memberInfo(params) {
    return http({
        url: "/api/member/info",
        data: params,
        forceLogin: true
    })
}

/**
 * 訂單數量
 */
export function orderNum(params) {
    return http({
        url: "/api/order/num",
        data: params,
        forceLogin: true
    })
}

/**
 * 優惠券數量
 */
export function couponNum(params) {
    return http({
        url: "/coupon/api/coupon/num",
        data: params,
        forceLogin: true
    })
}

/**
 * 我的足跡
 */
export function footprint(params) {
    return http({
        url: "/api/goodsbrowse/page",
        data: params,
        forceLogin: true
    })
}
/**
 * 會員等級列表
 */
export function levelList(params) {
    return http({
        url: "/api/memberlevel/lists",
        data: params,
        forceLogin: true
    })
}

/**
 * 我的背包列表
 */
 export function myBag(params) {
    return http({
        url: "/onlinebooking/api/onlinebooking/myBag",
        data: params,
        forceLogin: true
    })
}
/**
 * 在我的背包預約支付
 */
 export function orderService(params) {
    return http({
        url: "/onlinebooking/api/ordercreate/orderService",
        data: params,
        forceLogin: true
    })
}


